import { defineMessages } from 'react-intl';

export const freightNoCarriersMessageMessages = defineMessages({
  title: {
    defaultMessage: 'No carriers are available for this shipment.',
    id: 'VxCpeN',
    description: 'Title shown when a freight quote request returns no usable carrier offers',
  },
  body: {
    defaultMessage:
      'This shipment may be outside the supported shipping criteria, or no rates are currently available. Please review your shipment details or contact <contact>VolumeQuoting@shipstation.com</contact> for assistance.',
    id: '2JfTn6',
    description:
      'Body copy shown when no carriers are available for a WWEX/SpeedShip freight quote. <contact> wraps "VolumeQuoting@shipstation.com" as a mailto link.',
  },
});
